import { render, staticRenderFns } from "./JeecgOrderDMainModal.vue?vue&type=template&id=2b6ec919&scoped=true&"
import script from "./JeecgOrderDMainModal.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderDMainModal.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderDMainModal.vue?vue&type=style&index=0&id=2b6ec919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ec919",
  null
  
)

export default component.exports